/**
 * Actions list - store action names
 */
export enum SearchActions {
    // Tabs
    /** `useTabStore():` Sets the list of `SearchTab[]` Tab items */
    SET_TAB_ITEMS = "SET_TAB_ITEMS",
    /** `useTabStore():` Sets the current selected `SearchTab` Tab */
    SET_ACTIVETAB = "SET_ACTIVETAB",
    /** `useTabStore():` Sets the current selected `SearchTab` by a key property and value */
    SET_ACTIVETAB_BY_KEY = "SET_ACTIVETAB_BY_KEY",

    // Disclosures
    /** `useDisclosureStore():` Sets the list of `NormalizedDisclosure[]` Disclosure items */
    SET_DISCLOSURE_ITEMS = "SET_DISCLOSURE_ITEMS",
    /** `useDisclosureStore():` Sets the current selected `NormalizedDisclosure` Disclosure */
    SET_ACTIVE_DISCLOSURE = "SET_ACTIVE_DISCLOSURE",
    /** `useDisclosureStore():` Sets the current selected `NormalizedDisclosure` Disclosure by a key property and value from the `disclosures[]` list */
    SET_ACTIVE_DISCLOSURE_BY_KEY = "SET_ACTIVE_DISCLOSURE_BY_KEY",
    /** `useDisclosureStore():` Sets the value of the default "All Disclosures" `NormalizedDisclosure` and sets
     * the active disclosure to the value of 1st `NormalizedDisclosure` item from the `disclosures[]` array
     */
    SET_IS_ALL_DISCLOSURES = "SET_IS_ALL_DISCLOSURES",
    /** `useDisclosureStore():` Inserts or removes a Category ID into a Disclosure item's selected Categories list `Disclosure.selectedCategories[]` */
    SET_DISCLOSURE_CATEGORY = "SET_DISCLOSURE_CATEGORY",
    /** `useDisclosureStore():` Removes a Disclosure item's selected Categories inserted with `SET_DISCLOSURE_CATEGORY` */
    RESET_DISCLOSURE_CATEGORIES = "RESET_DISCLOSURE_CATEGORIES",

    // Categories
    /** `useCategoryStore():` Sets the list of `NormalizedCategory[]` Category items */
    SET_CATEGORY_ITEMS = "SET_CATEGORY_ITEMS",
    /** `useCategoryStore():` Sets the current selected `NormalizedCategory` Category */
    SET_ACTIVE_CATEGORY = "SET_ACTIVE_CATEGORY",
    /** `useCategoryStore():` Sets the current selected `NormalizedCategory` Category by a its `disclosureId` and a key property and value */
    SET_ACTIVE_CATEGORY_BY_KEY = "SET_ACTIVE_CATEGORY_BY_KEY",
    /** `useCategoryStore():` Sets the flag indicating if Topic counts have been fetched for a Category by `NormalizedCategory.categoryId` */
    SET_IS_FETCHED = "SET_IS_FETCHED",
    /** `useCategoryStore():` Inserts or removes a Topic ID into a Category item's selected Topic(s) list */
    SET_CATEGORY_TOPIC = "SET_CATEGORY_TOPIC",
    /** `useCategoryStore():` Removes a Category item's selected Topics inserted with `SET_CATEGORY_TOPIC` */
    RESET_CATEGORY_TOPICS = "RESET_CATEGORY_TOPICS",

    // Topics
    /** `useTopicStore():` Sets the list of `NormalizedTopic[]` Topic items */
    SET_TOPIC_ITEMS = "SET_TOPIC_ITEMS",
    /** `useTopicStore():` Sets the current selected `NormalizedTopic` Topic */
    SET_ACTIVE_TOPIC = "SET_ACTIVE_TOPIC",
    /** `useTopicStore():` Selects a Topic by inserting a `NormalizedTopic`'s unique string ID into the `useTopicStore()` - `selectedTopicIds[]` array
     * and increments the total number of selected documents (results) */
    SET_SELECTED_TOPIC = "SET_SELECTED_TOPIC",
    /** `useTopicStore():` Selects multiple Topic(s) by inserting a `string[]` array of `NormalizedTopic` unique string IDs into
     * the `useTopicStore()` - `selectedTopicIds[]` array and increments the total number of selected documents (results) */
    SET_SELECTED_TOPICS = "SET_SELECTED_TOPICS",
    /** `useTopicStore():` Sets the total number of documents under a `NormalizedTopic` Topic within the `useTopicStore() - topics[]` array */
    SET_TOPIC_COUNTS = "SET_TOPIC_COUNTS",
    /** `useTopicStore():` Sets the total count of documents (results) from all selected `NormalizedTopic` Topic(s) */
    SET_TOPICS_DOCS_COUNT = "SET_TOPICS_DOCS_COUNT",
    /** `useTopicStore():` Removes a Topic from the `useTopicStore()` - `selectedTopicIds[]` array and decrements the total number of selected documents (results) */
    REMOVE_SELECTED_TOPIC = "REMOVE_SELECTED_TOPIC",

    // Companies
    SET_COMPANY_ITEMS = "SET_COMPANY_ITEMS",
    SET_COMPANY_FILTERS = "SET_COMPANY_FILTERS",
    SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY",
    REMOVE_SELECTED_COMPANY = "REMOVE_SELECTED_COMPANY",
    RESET_SELECTION = "RESET_SELECTION",

    // Cache (Categories and Topics cache list)
    /** `useCacheStore():` Sets the list of `NormalizedCategory[]` Categories "pages" or "images" cache */
    SET_CACHE_CATEGORIES = "SET_CACHE_CATEGORIES",
    /** `useCacheStore():` Sets the list of `NormalizedTopic[]` Topics "pages" or "images" cache */
    SET_CACHE_TOPICS = "SET_CACHE_TOPICS",

    // Helpers (miscellaneous)
    /** `useHelperStore():` Sets the flag that indicates if the Search pop-up modal is open or closed */
    SET_IS_MODAL_OPEN = "SET_IS_MODAL_OPEN",
    /** `useHelperStore():` Sets the flag if the Search pop-up modal is fetching asynchronous data */
    SET_IS_LOADING = "SET_IS_LOADING",
    /** `useHelperStore():` Sets the flag upon encountering errors withing the Search pop-up modal */
    SET_IS_ERROR = "SET_IS_ERROR",
    /** `useHelperStore():` Sets the search pop-up modal's viewing mode */
    SET_SEARCH_VIEW_MODE = "SET_SEARCH_VIEW_MODE",
    /** `useHelperStore():` Sets the search keyword */
    SET_TOPIC_KEYWORD = "SET_TOPIC_KEYWORD",
    /** `useHelperStore():` Sets the app initialized flag - indicating a successfull initial data fetch */
    SET_IS_INITIALIZED = "SET_IS_INITIALIZED"
}

export enum FilterActions {
    SET_COMPANIES_DATA = "SET_COMPANIES_DATA",
    SET_INDUSTRIES_DATA = "SET_INDUSTRIES_DATA",
    SET_YEAR_FILTERS = "SET_YEAR_FILTERS",
    SET_INDUSTRY_FILTERS = "SET_INDUSTRY_FILTERS",
    SET_COMPANY_FILTERS = "SET_COMPANY_FILTERS",
    SET_IS_LOADING_YEARS = "SET_IS_LOADING_YEARS",
    SET_IS_LOADING_INDUSTRIES = "SET_IS_LOADING_INDUSTRIES",
    SET_IS_LOADING_COMPANIES = "SET_IS_LOADING_COMPANIES"
}
